import { SVGProps } from 'react';

const FolderHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.638 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v3.417M14.62 18.8a2.248 2.248 0 0 1 .924-3.696 2.25 2.25 0 0 1 2.456.732 2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.996.996 0 0 1-1.507 0z"
    />
  </svg>
);
export default FolderHeart;
